
import React from 'react'
import {  useLocation, useNavigate } from "react-router-dom";
import Swal from 'sweetalert2';
import resendCode from "../../services/sendOTP.service";
import deviceContextData from '../../types/deviceContextData.type';
import errorFace from '../../assets/images/errorFace.svg';

interface ICountdown {
    seconds: number;
    sessionId: string;
}

const CountDownTimer = ({  seconds = 60, sessionId }: ICountdown) => {

    const navigate = useNavigate();

    const state = useLocation();

   

    const [time, setTime] = React.useState<ICountdown>({seconds,sessionId});
    
    const tick = () => {
        if ( time.seconds === 0) 
            reset()
        else{
            setTime({ seconds: time.seconds - 1, sessionId });
        }
    };

    const reset = () => setTime({seconds: time.seconds, sessionId});

    React.useEffect(() => {
        const timerId = setInterval(() => tick(), 1000);
        return () => clearInterval(timerId);
    });
   
    
    const sendCode = () => {
      setTime({seconds: 60,sessionId});
      const data: deviceContextData = {
        userContextData: {
            deviceInfo: {
              securityProfileId: 'P1-Web',
              deviceFingerPrint: '',
              clientDeviceId: '',
              simIccid: '',
              deviceBrand: 'Chrome',
              deviceModel: 'emulator_arm64',
              deviceOS: 'Windows',
              imei: '',
              fcmDeviceId: '',
              patovikSignature: '',
              appVersion: '2.133.0',
              timestamp: '1654288297905',
              debugEnabled: true
            }
          }
      };
      resendCode.resendCode(data, state.state.sessionId)
      .then((response: any) => {

      })
      .catch((e: any) => {
          Swal.fire({
            title: '¡Ooops!',
            text:e.response.data.message,
            imageUrl: errorFace,
            imageWidth: 150,
            imageHeight: 150,
            imageAlt: 'Custom image',
          }).then((result) => {
            if (result.isConfirmed || result.isDismissed) {
                navigate('/');
            }
          })
      });
    };
    
    return (
        <div>
            { time.seconds === 0 ? (
                <p onClick={sendCode} className="text-gray-600 underline cursor-pointer ">Volver a enviar código</p> 
            ) : (
                <p className="text-gray-400 dark:text-white">Volver a enviar en {`${time.seconds.toString().padStart(2, '0')}`} seg.</p> 
            )}
        </div>
    );
}


export default CountDownTimer;